<script>
  import options from './UserPostsList.options'
  export default options
</script>

<template>
  <article class="kb-user-posts-list">
    <span v-if="posts.length > 0" class="kb-user-posts-list__title">{{ posts.length }} {{ getLabel('resultCountTitle') }}</span>

    <ul class="kb-user-posts-list__items">
      <li class="kb-user-posts-list__items-item" v-for="post, index in posts" :key="index">
        <GroupPost 
          :result="post"
          :groupId="post.groupId"
          :handlePostClick="handlePostClick"
        />
      </li>
    </ul>

    <div class="kb-general-search__more-results" v-if="posts.length > 0">
      <span class="kb-general-search__more-results__text">{{ getLabel('resultOutForTitle', [posts.length, totalNumberOfPosts]) }}</span>
      <template v-if="totalNumberOfPosts > posts.length">
        <button v-on:click="getMorePosts" class="kb-button kb-button--full-color">
          {{getLabel('showMoreButtonText')}}
        </button>
      </template>
    </div>

    <template v-if="!totalNumberOfPosts && !showSpinner && posts.length === 0">
      <div class="kb-general-search__no-results">
        <h2>{{ getLabel('noResultTitle') }}</h2>
        <p class="kb-general-search__no-results__summary">
          {{ getLabel('noResultDesc') }}
        </p>
        <a
          :href="getLabel('noResultButtonHref')"
          class="kb-button kb-button--full-color-spot"
          >{{ getLabel('noResultButtonText') }}</a
        >
      </div>
    </template>

    <div v-if="showSpinner" class="kb-spinner-overlay">
      <div class="kb-spinner-overlay__spinner"></div>
    </div>
  </article>
</template>
